import React, { useCallback, useContext, useEffect, useState } from 'react'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import axios from 'axios';
import { LoadingContext } from '../../context/LoadingContext';
const config = require('../../config.json')
export default function Level({ ipAddress, loginData }) {
    const [account, setAccount] = useState(loginData?.ulid);
    const [info, setInfo] = useState({});
    const [loading, setLoading] = useContext(LoadingContext)
    const handleLoad = useCallback(() => {
        setLoading(true)
        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid,
            "code": "RRI"
        });

        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}/income`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        // console.log(axiosConfig)
        axios.request(axiosConfig)
            .then((response) => {
                setInfo(response.data.info)
                console.log(response.data)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [account, ipAddress, loginData.auth, loginData.token, loginData.ulid, setLoading])


    useEffect(() => {

        handleLoad()
    }, [handleLoad])

    return (
        <>
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    <div className="content-wrapper mb-4">
                        <div className="container-xxl flex-grow-1 container-p-y pt-2">
                            <div className='row'>
                                <div className="col-md-12 mb-2">
                                    <div className="card">
                                        <div className="card-header align-items-center ">
                                            <div className="card-title mb-0">
                                                <h6 className="m-0 me-2 text-center text-success">Ad Manager Royalty</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                    <div className="card" >
                                        <div className="card-body dashinc mb-1" >
                                            <div className="d-flex justify-content-between">
                                                <div className="card-info">
                                                    <p className="card-text m-0 text-sm">Total Income</p>


                                                </div>
                                                <div className="card-info">
                                                    <div className="d-flex align-items-end ">
                                                        <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {info?.total}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                    <div className="card" >
                                        <div className="card-body dashinc mb-1" >
                                            <div className="d-flex justify-content-between">
                                                <div className="card-info">
                                                    <p className="card-text m-0 text-sm">Today Income</p>
                                                </div>
                                                <div className="card-info">
                                                    <div className="d-flex align-items-end ">
                                                        <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {info?.today}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                    <div className="card" >
                                        <div className="card-body dashinc mb-1" >
                                            <div className="d-flex justify-content-between">
                                                <div className="card-info">
                                                    <p className="card-text m-0 text-sm">Yesterday Income</p>
                                                </div>
                                                <div className="card-info">
                                                    <div className="d-flex align-items-end ">
                                                        <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {info?.yday}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-md-12  mb-2">
                                    <div className="card">
                                        <div className="card-header dashinc align-items-center mb-2">
                                            <div className="card-title mb-0">
                                                <h6 className="m-0 me-2 text-center text-success">Details</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    info?.data?.map((list, index) => {
                                        return (
                                            <div className="col-md-4  mb-1" id={index + 1} key={index + 111}>
                                                <div className="card h-100">
                                                    <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                                        <div className="col-md-12">
                                                            <div className='row d-flex justify-content-between'>
                                                                <div className='col-6 text-left'>
                                                                    <span className="text-black text-sm">Amount : {list?.netAmount}</span>
                                                                </div>
                                                                <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                    <small className="text-sm">Date : {list?.dt}</small>
                                                                </div>
                                                            </div>
                                                            <div className='row d-flex justify-content-between'>
                                                                <div className='col-6 text-left'>
                                                                    <small className="text-sm"> On Total :  {list?.onTotal} ({list?.asPer}%)</small>
                                                                </div>
                                                                <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                    <small className="text-sm">Service Charge: {list?.serviceCharge} </small>
                                                                </div>
                                                            </div>
                                                            <div className='row d-flex justify-content-between'>
                                                                <div className='col-6 text-left'>
                                                                    <small className="text-sm"> Genrated :  {list?.amount} </small>
                                                                </div>
                                                                <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                    <small className="text-sm">Refrence: {list?.refrence} </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}
